import { useMemo } from 'react';
import { TeamChatTypes } from '@frontend/api-team-chat';
import { extractUrls } from '@frontend/components';
import { useTeamChatSelector } from '../providers/team-chat.provider';
import { getUserFullName } from '../utils';

/**
 * Hook to extract all parseable content from message text
 */
export const useMessageContent = (message: string, mentionedUsers?: TeamChatTypes.User[]) => {
  const currentUser = useTeamChatSelector((ctx) => ctx.user);

  const allDelimiters = useMemo(
    () => [
      ...extractUrls(message),
      ...(mentionedUsers ? mentionedUsers.map((user) => `@${getUserFullName(user.firstName, user.lastName)}`) : []),
    ],
    [message, mentionedUsers]
  );

  return {
    allDelimiters,
    currentUser,
  };
};
